<template>
	<div>
        <el-select v-model="currentValue" :placeholder="placeholder" style="width:100%"
        :filterable="mulSelect"
        :multiple="mulSelect"
	    :disabled="disabled"
        :filter-method="handleFilterMethods"
        @change="selectChange"
        >
          <el-option
            v-for="item in defListData"
            :label="item[labelField]"
            :value="item[keyField]"
            :key="item[keyField]">
          </el-option>
        </el-select>
	</div>
</template>
<script>
	import modelRouter from './refModelRouter.js';
	export default{
		props:{
			refModel:Object,
			refCode:String,
			mulSelect:{
                type:Boolean,
                default:false
            },
			disabled:{
				type:Boolean,
				default:false
			},
            checkStrictly:{
                type:Boolean,
                default:false
            },
            showNoExists:{     //是否显示不存在的下拉值   只在下拉状态显示值
                type:Boolean,
                default:true                
            },
            filterMethod:Function,  //用来对展示结果集进行过滤
            treeCondition:Object,  //树条件，用于传递给后端接口
            value:[String, Array],
			placeholder:{
				type:String,
				default:'请选择'
			}
		},
		data(){
			var _model = this.refModel?this.refModel:modelRouter[this.refCode];
			var _refType = _model.refConfig.refType;
			return {
				model:_model,
				refType:_refType,
				defListData:[],
				keyField:_model.getRefFields().id,
				labelField:_model.getRefFields().name,
                currentValue:this.value,
                allDefListData: []
			}
		},
		watch:{
            value:{
                immediate: true,
                handler:function(v, oldv){
                	if(!v) return this.currentValue = this.mulSelect ? [] : v;
                	if(this.showNoExists) v = this.existsList(v);
                	this.currentValue = v?v:'';
                }
            },
            currentValue:function(v){
                this.$emit('input',v);
            },
            treeCondition:function(v){

            	this.model.setTreeCondition(v);
            	this.loadListData();
            }
		},
        components: {
        },
		created:function(){

			this.initData();
		},
		methods:{
            /**
             * @name: 
             * @Author: shuSheng
             * @msg: 处理select下拉框数据过多卡死问题
             * @param {type} 
             * @return: 函数注释
             */
            handleFilterMethods(query = '') {
                let arr = this.allDefListData.filter(item => {
                    return item.dishName.includes(query);
                })
                if ( arr.length > 50 ) {
                    this.defListData = arr.slice(0, 50);
                } else {
                    this.defListData = arr;
                }
            },
			initData:function(){
				this.loadListData();
			},
			loadListData:function(){
				var _self = this;
				this.model.getClassData(function(data){
					if ( _self.mulSelect ) {
                        _self.allDefListData = data.data;
                        _self.handleFilterMethods();
                    } else {
                        _self.defListData=data.data;
                    }
					if(_self.showNoExists) _self.currentValue = _self.existsList(_self.currentValue);
				});
			},
			//判断值是否在下拉列表中存在
			existsList:function(v){
				var vlst = this.mulSelect ? v : [v];
				var newLst = [];
				if(!this.defListData || !this.defListData.length) return v;
				vlst.forEach(l=>{
					for(var i=0;i<this.defListData.length;i++){
						if(this.defListData[i][this.keyField] == l){
							newLst.push(l);
							return;
						}
					}
				});
				return this.mulSelect?newLst:newLst[0];
			},
			selectChange:function(val){
				
				if(this.mulSelect){
					var selData = this.defListData.filter(d =>  val.indexOf(d[this.keyField])>-1);
				}else{
					var selData = this.defListData.find(d =>  d[this.keyField]==val);
				}
				if(selData) {
					//this.$emit("input", selData);
					this.$emit("selectChange", selData);
				}
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/pub/components/baseRef/refSelect.vue